var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('purchase-sector', {
    attrs: {
      "title": "구매수량"
    }
  }, [_c('div', {
    staticClass: "purchase-amount"
  }, [_c('purchase-amount-form', {
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form,
      callback: function callback($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }), _c('v-divider'), _c('purchase-amount-view', {
    model: {
      value: _vm.form,
      callback: function callback($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }), _c('v-divider'), _c('purchase-amount-noti')], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }